/**
 * User-facing copy when the selected start is after the selected end (calendar days).
 */
export const DATE_RANGE_ORDER_ERROR =
  "Start date cannot be after end date. End date cannot be before start date.";

function dayStartTimestamp(value: unknown): number | null {
  if (value == null || value === "") return null;
  if (value instanceof Date) {
    if (Number.isNaN(value.getTime())) return null;
    return new Date(
      value.getFullYear(),
      value.getMonth(),
      value.getDate(),
    ).getTime();
  }
  if (typeof value === "string") {
    const s = value.trim();
    const isoDay = /^(\d{4})-(\d{2})-(\d{2})$/.exec(s);
    if (isoDay) {
      const y = Number(isoDay[1]);
      const m = Number(isoDay[2]) - 1;
      const d = Number(isoDay[3]);
      const dt = new Date(y, m, d);
      if (Number.isNaN(dt.getTime())) return null;
      return dt.getTime();
    }
  }
  const d = new Date(value as string | number);
  if (Number.isNaN(d.getTime())) return null;
  return new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
}

/**
 * When both values parse to a calendar day, returns an error if start is after end.
 * If either is missing or invalid, returns null (optional range or incomplete input).
 */
export function getDateRangeOrderError(
  start: unknown,
  end: unknown,
): string | null {
  const a = dayStartTimestamp(start);
  const b = dayStartTimestamp(end);
  if (a === null || b === null) return null;
  if (a > b) return DATE_RANGE_ORDER_ERROR;
  return null;
}
